import { usePermissions } from 'views/components/PermissionCheck/usePermissions'

export const useDispatchingPerms = () => {
  return {
    canChangeStatus: usePermissions(['deals.change_dp_status']),
    canChangeBank: usePermissions(['deals.change_dp_bank']),
    canChangeLoan: usePermissions(['deals.change_dp_loan_agreement']),
    canChangeSource: usePermissions(['deals.change_dp_source']),
    canAddLoan: usePermissions(['deals.add_loanagreement']),
  }
}
